import axiosInstance from './axiosInterceptor';

export const apiRoute = {
  auth: {
    loginUrl: '/auth/login',
    profileUrl: '/auth/profile',
    onboardGymUrl: '/auth/onboard-gym'
  },
  trainer: {
    trainerUrl: '/feature/trainer',
    trainerDetailsUrl: '/feature/trainer-details',
    trainerInactiveToggleUrl: '/feature/trainer-inactive-toggle'
  },
  master: {
    specializationUrl: '/feature/specialization'
  },
  feature: {
    memberRequestUrl: '/feature/gym-membership-request',
    updateMemberRequestUrl: '/feature/updated-gym-status-membership-request',
    approvedUserListUrl: '/feature/approved-user-list',
    allUsersUrl: '/feature/all-user',
    trackingActivityUrl: '/feature/tracking-activity',
    monthlyAnalysisUrl: '/feature/monthly-analysis',
    dashboardCountDataUrl: '/feature/dashboard-count-data',
    membershipWithTypeUrl: '/feature/membership-with-type',
    membershipRequestDashboardUrl: '/feature/membership-request',
    memberRegistrationUrl: '/feature/member-registration'
  }
};

//  authentication
export const adminLogin = (data) => axiosInstance.post(apiRoute.auth.loginUrl, data);

export const PROFILE = {
  fetchGymProfile: () => axiosInstance.get(apiRoute.auth.onboardGymUrl),
  fetchProfile: () => axiosInstance.get(apiRoute.auth.profileUrl),
  updateProfile: (body) => axiosInstance.put(apiRoute.auth.profileUrl, body)
};

export const TRAINER = {
  fetchTrainer: (params) => axiosInstance.get(apiRoute.trainer.trainerUrl, { params }),
  fetchTrainerDetails: (trainerId) => axiosInstance.get(apiRoute.trainer.trainerDetailsUrl, { params: { trainerId } }),
  CreateTrainer: (body) => axiosInstance.post(apiRoute.trainer.trainerUrl, body),
  updateTrainer: (body) => axiosInstance.put(apiRoute.trainer.trainerUrl, body),
  toggleTrainerInactive: (trainerId) => axiosInstance.patch(apiRoute.trainer.trainerInactiveToggleUrl, { trainerId }),
  removeTrainer: (params) => axiosInstance.delete(apiRoute.trainer.trainerUrl, { params })
};

export const SPECIALIZATION = {
  fetchSpecialization: (params) => axiosInstance.get(apiRoute.master.specializationUrl, { params }),
  CreateSpecialization: (body) => axiosInstance.post(apiRoute.master.specializationUrl, body),
  updateSpecialization: (body) => axiosInstance.put(`${apiRoute.master.specializationUrl}/${body._id}`, body),
  removeSpecialization: (id) => axiosInstance.delete(`${apiRoute.master.specializationUrl}/${id}`)
};

export const REQUEST = {
  fetchMembershipRequest: () => axiosInstance.get(apiRoute.feature.memberRequestUrl),
  updateMembershipRequestStatus: (body) => axiosInstance.patch(apiRoute.feature.updateMemberRequestUrl, body),
  fetchApprovedUserList: (params) => axiosInstance.get(apiRoute.feature.approvedUserListUrl, { params }),
  fetchAllUsers: (params) => axiosInstance.get(apiRoute.feature.allUsersUrl, { params }),
  fetchTrackingActivity: (params) => axiosInstance.get(apiRoute.feature.trackingActivityUrl, { params })
};

export const ANALYSIS = {
  fetchMonthlyAnalysis: (userId) =>
    axiosInstance.get(apiRoute.feature.monthlyAnalysisUrl, {
      params: { userId }
    })
};

export const DASHBOARD = {
  fetchCountData: () => axiosInstance.get(apiRoute.feature.dashboardCountDataUrl),
  fetchMembershipWithType: () => axiosInstance.get(apiRoute.feature.membershipWithTypeUrl),
  fetchMembershipRequests: (params) => axiosInstance.get(apiRoute.feature.membershipRequestDashboardUrl, { params }),
  fetchMemberRegistrations: () => axiosInstance.get(apiRoute.feature.memberRegistrationUrl)
};
